import React, { useEffect, useState } from 'react';
import { Typography } from '@telus-uds/components-web';
import Switch from 'react-switch';
import request from '../../../../utils/request';
import ValidateLoader from '../../../../UI/validateLoader';
import {
  categoryFormIds as formIds,
  categoryFormNameMap,
  categoryFormKeys
} from '../../../../utils/constant';
import { useLocalizedStringsContext } from '../../../../context/LocalizedStringsContext';
import { useLocaleContext } from '../../../../context/LocaleContext';
import {
  getContentfulData,
  contentfulFormConfig,
  getData
} from '../../../../contentful';
import {
  formCategoryStyle,
  selected,
  unselected,
  unselectedcolor,
  colorselected
} from '../../../../form/style';

const FormFreeze = () => {
  const [isReferralFreezed, setReferralFreezed] = useState(0);
  const [isWirelessFreezed, setWirelessFreezed] = useState(0);
  const [isBRPFreezed, setBRPFreezed] = useState(0);
  const [isVULFormFreezed, setVULFormFreezed] = useState(0);
  const [isFMFreezed, setFMFreezed] = useState(0);
  const [isOCDRFreezed, setOCDRFreezed] =useState(0);
  const [isCSFreezed, setCSFreezed] =useState(0);
  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState(null);
  const locale = useLocaleContext();
  const config = { ...contentfulFormConfig, locale };

  const localizedStrings = useLocalizedStringsContext();
  const {
    USERS: {
      FORM: {
        MESSAGE: { LOADING }
      }
    }
  } = localizedStrings;

  const getFormFreezeDetails = async () => {
    setLoading(true);
    try {
      const [
        {
          data: { value: referralVal }
        },
        {
          data: { value: wirelessVal }
        },
        {
          data: { value: brpVal }
        },
        {
          data: { value: vulcanVal }
        },
        {
          data: { value: fmVal }
        },
        {
          data: { value: ocdrVal }
        },
        {
          data: { value: csVal }
        }
      ] = [
        await request.get(`/options/${formIds.REFERRAL}`),
        await request.get(`/options/${formIds.WIRELESS}`),
        await request.get(`/options/${formIds.BRP}`),
        await request.get(`/options/${formIds.VULCAN}`),
        await request.get(`/options/${formIds.FM}`),
        await request.get(`/options/${formIds.OCDR}`),
        await request.get(`/options/${formIds.CS}`)
      ];
      const [
        referralFormFreeze,
        wirelessFormFreeze,
        brpFormFreeze,
        vulcanFormFreeze,
        fmFormFreeze,
        csFormFreeze,
        ocdrFormFreeze
      ] = [
        JSON.parse(referralVal),
        JSON.parse(wirelessVal),
        JSON.parse(brpVal),
        JSON.parse(vulcanVal),
        JSON.parse(fmVal),
        JSON.parse(ocdrVal),
        JSON.parse(csVal)
      ];
      setReferralFreezed(referralFormFreeze);
      setWirelessFreezed(wirelessFormFreeze);
      setBRPFreezed(brpFormFreeze);
      setVULFormFreezed(vulcanFormFreeze);
      setFMFreezed(fmFormFreeze);
      setOCDRFreezed(csFormFreeze);
      setCSFreezed(ocdrFormFreeze);
    } finally {
      setLoading(false);
    }
  };

  const setFormFreeze = async (id, val) => {
    const newValue = val === 0 ? 1 : 0;
    const { status } = await request.post(`/options/${id}`, {
      value: newValue
    });
    if (status === 200) {
      if (id === formIds.REFERRAL) {
        setReferralFreezed(newValue);
      } else if (id === formIds.WIRELESS) {
        setWirelessFreezed(newValue);
      } else if (id === formIds.BRP) {
        setBRPFreezed(newValue);
      } else if (id === formIds.VULCAN) {
        setVULFormFreezed(newValue);
      } else if (id === formIds.FM) {
        setFMFreezed(newValue);
      } else if (id === formIds.OCDR) {
        setOCDRFreezed(newValue);
      } else if (id === formIds.CS) {
        setCSFreezed(newValue);
      }
    }
  };

  useEffect(() => {
    getFormFreezeDetails();
  }, []);

  useEffect(() => {
    getContentfulData(config).then(res => {
      const { formCategories } = getData(res);
      const contentfulCategories = formCategories.map(
        ({ fields: { title, name, image, forms } }) => ({
          title,
          name,
          image,
          forms
        })
      );
      const formCategoriesObj = {};
      contentfulCategories.forEach(cat => {
        return (formCategoriesObj[categoryFormNameMap[cat.name]] = cat);
      });
      setCategories(formCategoriesObj);
    });
  }, [locale]);
  return (
    <>
      <div className="layout-container">
        {loading || !categories ? (
          <ValidateLoader message={LOADING} />
        ) : (
          <div className="checking form-freeze-section-grid">
            <div style={formCategoryStyle(true)}>
              <div style={isReferralFreezed ? unselected : selected}>
                <div style={isReferralFreezed ? unselectedcolor : colorselected}>
                  <Typography heading="h4" variant={{ size: 'h4' }} block>
                    {categories[categoryFormKeys.REFERRAL]?.title}
                  </Typography>
                </div>
                <br />
                <br />
                <>
                  <span>
                    <Switch
                      onColor="#4B286D"
                      onChange={() =>
                        setFormFreeze(formIds.REFERRAL, isReferralFreezed)
                      }
                      checked={(!formIds.REFERRAL, !isReferralFreezed)}
                    />
                  </span>
                  &nbsp;
                </>
              </div>
            </div>
            <div style={formCategoryStyle(true)}>
              <div style={isWirelessFreezed ? unselected : selected}>
                <div style={isWirelessFreezed ? unselectedcolor : colorselected}>
                  <Typography heading="h4" variant={{ size: 'h4' }} block>
                    {categories[categoryFormKeys.WIRELESS]?.title}
                  </Typography>
                </div>
                <br />
                <br />
                <>
                  <span>
                    <Switch
                      onColor="#4B286D"
                      onChange={() =>
                        setFormFreeze(formIds.WIRELESS, isWirelessFreezed)
                      }
                      checked={(!formIds.WIRELESS, !isWirelessFreezed)}
                    />
                  </span>
                  &nbsp;
                </>
              </div>
            </div>
            <div style={formCategoryStyle(true)}>
              <div style={isBRPFreezed ? unselected : selected}>
                <div style={isBRPFreezed ? unselectedcolor : colorselected}>
                  <Typography heading="h4" variant={{ size: 'h4' }} block>
                    {categories[categoryFormKeys.BRP]?.title}
                  </Typography>
                </div>
                <br />
                <br />
                <>
                  <span>
                    <Switch
                      onColor="#4B286D"
                      onChange={() => setFormFreeze(formIds.BRP, isBRPFreezed)}
                      checked={(!formIds.BRP, !isBRPFreezed)}
                    />
                  </span>
                  &nbsp;
                </>
              </div>
            </div>
            <div style={formCategoryStyle(true)}>
              <div style={isVULFormFreezed ? unselected : selected}>
                <div style={isVULFormFreezed ? unselectedcolor : colorselected}>
                  <Typography heading="h4" variant={{ size: 'h4' }} block>
                    {categories[categoryFormKeys.VULCAN]?.title}
                  </Typography>
                </div>
                <br />
                <br />
                <>
                  <span>
                    <Switch
                      onColor="#4B286D"
                      onChange={() =>
                        setFormFreeze(formIds.VULCAN, isVULFormFreezed)
                      }
                      checked={(!formIds.VULCAN, !isVULFormFreezed)}
                    />
                  </span>
                  &nbsp;
                </>
              </div>
            </div>
            <div style={formCategoryStyle(true)}>
              <div style={isFMFreezed ? unselected : selected}>
                <div style={isFMFreezed ? unselectedcolor : colorselected}>
                  <Typography heading="h4" variant={{ size: 'h4' }} block>
                    {categories[categoryFormKeys.FM]?.title}
                  </Typography>
                </div>
                <br />
                <br />
                <>
                  <span>
                    <Switch
                      onColor="#4B286D"
                      onChange={() => setFormFreeze(formIds.FM, isFMFreezed)}
                      checked={(!formIds.FM, !isFMFreezed)}
                    />
                  </span>
                  &nbsp;
                </>
              </div>
            </div>
            <div style={formCategoryStyle(true)}>
              <div style={isOCDRFreezed ? unselected : selected}>
                <div style={isOCDRFreezed ? unselectedcolor : colorselected}>
                  <Typography heading="h4" variant={{ size: 'h4' }} block>
                    {categories[categoryFormKeys.OCDR]?.title}
                  </Typography>
                </div>
                <br />
                <br />
                <>
                  <span>
                    <Switch
                      onColor="#4B286D"
                      onChange={() => setFormFreeze(formIds.OCDR, isOCDRFreezed)}
                      checked={(!formIds.OCDR, !isOCDRFreezed)}
                    />
                  </span>
                  &nbsp;
                </>
              </div>
            </div>
            <div style={formCategoryStyle(true)}>
              <div style={isCSFreezed ? unselected : selected}>
                <div style={isCSFreezed ? unselectedcolor : colorselected}>
                  <Typography heading="h4" variant={{ size: 'h4' }} block>
                    {categories[categoryFormKeys.CS]?.title}
                  </Typography>
                </div>
                <br />
                <br />
                <>
                  <span>
                    <Switch
                      onColor="#4B286D"
                      onChange={() => setFormFreeze(formIds.CS, isCSFreezed)}
                      checked={(!formIds.CS, !isCSFreezed)}
                    />
                  </span>
                  &nbsp;
                </>
              </div>
            </div>  
          </div>
        )}
      </div>
    </>
  );
};

export default FormFreeze;
